import React, { useState } from "react";
import MedicalErrorForm from "./forms/MedicalErrorForm";
import AdverseEventForm from "./forms/AdverseEventForm";
import InfectionForm from "./forms/InfectionForm";
import { getLang } from "../../store/uiStore";
import "./CreateIncident.css";

export default function CreateIncident() {
  const [type, setType] = useState(null);
  const lang = getLang();

  const tr = {
    title:
      lang === "ru"
        ? "Новое экстренное извещение"
        : "Хабарномаи фаврии нав",

    subtitle:
      lang === "ru"
        ? "Выберите тип извещения для заполнения формы."
        : "Барои пур кардани шакл навъи хабарномаро интихоб кунед.",

    infection:
      lang === "ru"
        ? "Опасное инфекционное заболевание"
        : "Бемории хавфноки сироятӣ",

    infectionText:
      lang === "ru"
        ? "Регистрация случая опасного инфекционного заболевания."
        : "Сабти ҳолати бемории хавфноки сироятӣ.",

    medicalError:
      lang === "ru"
        ? "Медицинская ошибка"
        : "Хатои тиббӣ",

    medicalErrorText:
      lang === "ru"
        ? "Регистрация случая медицинской ошибки."
        : "Сабти ҳолати хатои тиббӣ.",

    adverse:
      lang === "ru"
        ? "Нежелательное явление"
        : "Ҳодисаи номатлуб",

    adverseText:
      lang === "ru"
        ? "Регистрация нежелательного явления."
        : "Сабти ҳодисаи номатлуб.",

    select:
      lang === "ru"
        ? "Выбрать"
        : "Интихоб кардан",
  };

  const options = [
    {
      key: "infection",
      title: tr.infection,
      text: tr.infectionText,
      icon: "infection",
    },
    {
      key: "medical-error",
      title: tr.medicalError,
      text: tr.medicalErrorText,
      icon: "medical",
    },
    {
      key: "adverse-event",
      title: tr.adverse,
      text: tr.adverseText,
      icon: "adverse",
    },
  ];

  if (type === "medical-error") {
    return <MedicalErrorForm />;
  }

  if (type === "infection") {
    return <InfectionForm />;
  }

  if (type === "adverse-event") {
    return <AdverseEventForm />;
  }

  return (
    <main className="nizom-create-incident-page">
      <div className="nizom-create-incident-container">
        <header className="nizom-create-incident-header">
          <div className="nizom-create-incident-title-row">
            <span className="nizom-create-incident-title-accent" />
            <div>
              <h1>{tr.title}</h1>
              <p>{tr.subtitle}</p>
            </div>
          </div>
        </header>

        <section className="nizom-create-incident-options">
          {options.map((option) => (
            <button
              type="button"
              key={option.key}
              className={`nizom-create-incident-option ${option.key}`}
              onClick={() => setType(option.key)}
            >
              <span className="nizom-create-incident-option-icon" aria-hidden="true">
                {option.icon === "infection" && (
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M8.5 8.5L6 6m9.5 2.5L18 6M8.5 15.5L6 18m9.5-2.5L18 18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                    />
                    <circle
                      cx="12"
                      cy="12"
                      r="5"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.7"
                    />
                    <path
                      d="M12 9v6M9 12h6"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.6"
                      strokeLinecap="round"
                    />
                  </svg>
                )}

                {option.icon === "medical" && (
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M8 4h8a2 2 0 0 1 2 2v14H6V6a2 2 0 0 1 2-2z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.7"
                    />
                    <path
                      d="M9 4.5V3h6v1.5M9 10h6M9 14h4"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                    />
                  </svg>
                )}

                {option.icon === "adverse" && (
                  <svg viewBox="0 0 24 24">
                    <path
                      d="M12 3l9 17H3L12 3z"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M12 8v5M12 16.5v.1"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.7"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
              </span>

              <span className="nizom-create-incident-option-content">
                <strong>{option.title}</strong>
                <span>{option.text}</span>
              </span>

              <span className="nizom-create-incident-option-action">
                {tr.select}
                <span aria-hidden="true">›</span>
              </span>
            </button>
          ))}
        </section>
      </div>
    </main>
  );
}
